<template>
  <div
    class="modal modal--backdrop"
    role="dialog"
    id="myModal"
    tabindex="-1"
    aria-describedby="modal-description3"
  >
    <section class="modal__content" role="document">
      <div id="modal-description3" class="screenreader-only">
        Dit is de beschrijving van de
        <span xml:lang="en-US">modal</span>. De Escape knop annuleert en sluit het venster.
      </div>
      <header class="modal__title">
        <h1>Statusoverzicht</h1>
        <button class="modal__close-button">
          <i class="icon icon-cross"></i>
          Sluit
        </button>
      </header>

      <div class="modal__body" role="document" tabindex="0"  v-if="selectedInitiative != null && selectedInitiative.initiatiefId > 0">
        <div v-bind:class="toonStatus(selectedInitiative.StatusExtern.statusExtern)">
          <div class="notification__content">
            <span>
              Dit initiatief is {{
              formatIniatiefText(selectedInitiative.StatusExtern.statusExtern.toLowerCase())
              }}
            </span>
          </div>
        </div>

        <div>
          <h2 class="is-h3">{{labels.MODAL_ALGEMEEN_TITEL}}</h2>
          <p>
            {{labels.MODAL_ALGEMEEN_TEKST}}
          </p>
        </div>

        <table
          class="table table--responsive"
          aria-describedby="reponsive-tabel"
          v-if="toonBeslissingsTabel"
        >
          <thead>
            <tr>
              <th scope="col">Onderwijssoort</th>
              <th class="align--right" scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-bind:key="beslissing.indicatiefId"
              v-for="beslissing in selectedInitiative.Beslissing"
            >
              <td data-col="Onderwijssoort" v-if="beslissing.soortOnderwijs != 'VBO'">
                {{
                toonOpleiding(beslissing.soortOnderwijs)
                }}
              </td>
              <td class="align--right" data-col="Status" v-if="beslissing.soortOnderwijs != 'VBO'">
                <span v-html="toonBeslissing(beslissing)" />
              </td>
            </tr>
          </tbody>
        </table>

        <table
          class="table table--responsive"
          aria-describedby="reponsive-tabel"
          v-if="toonBeslissingsTabel &&
          bepaalVBO(selectedInitiative.soortOnderwijs)
          "
        >
          <thead>
            <tr>
              <th scope="col">vbo profielen</th>
              <th class="align--right" scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-bind:key="beslissing.indicatiefId"
              v-for="beslissing in selectedInitiative
                .Beslissing"
            > 
              <td
                v-if="beslissing.soortOnderwijs == 'VBO'"
                data-col="Onderwijssoort"
              >{{ toonProfiel(beslissing.profielVBO) }}</td>
              <td class="align--right" data-col="Status" v-if="beslissing.soortOnderwijs == 'VBO'">
                <span v-html="toonBeslissingProfiel(beslissing)" />
                <!-- <span v-bind:class="toonBeslissing(beslissing)">
                  {{
                  beslissing.beslissing
                  }}
                </span> -->
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="toonBeslissingsTabel">
          <p>
              {{labels.MODAL_VBO_TITEL}}
          </p>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { toonDescription } from "../mixins/toonDescription";

export default {
  name: "ModalComponent",
  computed: {
    ...mapGetters(["selectedInitiative", "labels"]),
    toonBeslissingsTabel: function() {
      return (
        this.selectedInitiative.StatusExtern.statusExtern.toLowerCase() !=
          "afgewezen" && this.selectedInitiative.sector === "VO"
      );
    }
  },
  mixins: [toonDescription],
  methods: {
    bepaalVBO: function(soortOnderwijs) {
      var bepaalVBO = false;
      for (var i = 0; i < soortOnderwijs.length; i++) {
        if (soortOnderwijs[i].soortOnderwijs === "VBO") {
          bepaalVBO = true;
        }
      }
      return bepaalVBO;
    },
    toonBeslissing: function(beslissing) {
      let checkString= "";
      this.selectedInitiative.soortOnderwijs.forEach((element, index) => {
        if (element.soortOnderwijs !== 'VBO'){
          if (element.soortOnderwijs === beslissing.soortOnderwijs){
            checkString = element.ingetrokken ? "ingetrokken" : beslissing.beslissing.replace("_", " ").toLowerCase();  
          }
        }
      });
      return "<span class='" + this.toonClassStatus(checkString) + "'>" + checkString + "</span>";  
    },
    toonBeslissingProfiel: function(beslissing) {
      let checkString= "";
      this.selectedInitiative.soortOnderwijs.forEach((element, index) => {
        if (element.soortOnderwijs === 'VBO'){
          element.vboProfiel.forEach(profiel => {
            if (profiel.profiel === beslissing.profielVBO){
              checkString = profiel.ingetrokken ? "ingetrokken" : beslissing.beslissing.replace("_", " ").toLowerCase();      
            }
          })
        }
      }); 
      return "<span class='" + this.toonClassStatus(checkString) + "'>" + checkString + "</span>";
    },
    toonClassStatus: function(item){
      switch (item.toLowerCase()) {
        case "afgewezen":
        case "ingetrokken":
        case "buiten behandeling":
          return "label label--rood";
        case "toegewezen":
          return "label label--groen";
        default:
          return "";
      }
    },
    toonStatus: function(status) {
      switch (status.toLowerCase()) {
        case "afgewezen":
        case "ingetrokken":
          return "notification notification--error";
        case "deel toegewezen":
          return"notification notification--warning";
        case "toegewezen":
          return "notification notification--success";
        default:
          return "";
      }
    },
    formatIniatiefText: function(iniatiefText) {
      const toegewezen = "deel toegewezen";
      switch (iniatiefText) {
        case toegewezen:
          return "gedeeltelijk toegewezen";
        default:
         return iniatiefText;
      }
    }
  }
};
</script>
